import Layout from '@/layout'

const newsRouter = {
    path: '/news',
    component: Layout,
    meta: {
        title: '新闻资讯'
    },
    children: [
        {
            path: '',
            name: 'News',
            component: () => import('@/views/news/index')
        },
        {
            path: 'detail',
            name: 'NewsDetail',
            component: () => import('@/views/news/detail/index'),
            meta: {
                title: '详情'
            }
        }
    ]
}

export default newsRouter